<div [formGroup]="formGroup">
    <sc-checkbox-field formControlName="pickupTruckEnabled" labelDictionaryKey="tmc-yard.entity.transport.masterdata.pickupTruckEnabled"></sc-checkbox-field>
    <ng-container *ngIf="transport.masterdata.pickupTruckEnabled">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-string-field formControlName="numberplate" labelDictionaryKey="tmc-yard.entity.transport.masterdata.pickupTruckNumberPlate"></sc-string-field>
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-date-time-field-legacy formControlName="date"
        [label]="'time' | translate:['tmc-yard.entity.transport.masterdata.pickupTruckTime', translationService.language, translationService.revision]"></sc-date-time-field-legacy>
    </ng-container>
</div>
